export const CLOUD_ASSET_TABLE_NAME = 'cloud_assets';
